

















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';
import store from '@/store'; // @ is an alias to /src
import AuthComponent from '@/components/AuthComponent.vue';
import StampsComponent from '@/components/StampsComponent.vue';
import { ICompetition, IResponse } from '@/interfaces/objects';
import { stampService } from '@/services/stamp.service.ts';
import { ERROR_GEN_NETWORK } from '@/actions';
@Component({
    components: {
        AuthComponent,
        StampsComponent,
    },
})
export default class CompetitionsHome extends Vue {
        private isAuthenticated: boolean;
        private isLoaded: boolean;
        private cKey: string = '';
        private competition?: ICompetition;
        constructor() {
            super();
            this.isAuthenticated = this.$store.getters.isAuthenticated;
            this.isLoaded = false;
        }
        public async created() {
            // 1
            this.cKey = this.$route.params.key;
            this.isAuthenticated = store.getters.isAuthenticated;

            // if (key === 'a1bc') {
            //     // this.competition = 'stamps1';
            //     console.log('key: ', key);
            // }
        }
        public async mounted() {
            // 2
            await this.fetch();
        }

        public async authChanged() {
            this.isAuthenticated = this.$store.getters.isAuthenticated;
            if (this.isAuthenticated) {
                await this.fetch();
            }
        }

        public async fetch() {
            await stampService.fetch(this.cKey)
            .then((r: IResponse) => {
                if (r.success) {
                    // tslint:disable-next-line:no-console
                    // const data = (r.data as IPreview);
                    this.competition = r.data as ICompetition;
                    this.isLoaded = true;
                } else {
                    if (r.status === 401) {
                        this.isAuthenticated = false;
                    } else {
                        if (r.status === -1) {
                            const data = { code: -1, message: 'Network Error!' };
                            this.$store.dispatch(ERROR_GEN_NETWORK, data).then((response) => {
                                this.$router.push({ path: `/error` });
                            });
                        } else {
                            // tslint:disable-next-line:no-console
                            console.log('fail: ', r);
                        }
                    }
                }
            })
            .catch((c) => {
                // tslint:disable-next-line:no-console
                console.log('catch: ', c);
            });
        }
}
